<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      @depRowChange="depRowChange"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
        @updateLevel="openUpdateLevelDialog"
        :orgRow="orgRow"
        :depRow="parentDep"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="650px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :depCode="editFormDialogOptions.code"
        :orgRow="orgRow"
        :parentDep="parentDep"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>

    <UpdateLevelDialog
      :visible.sync="updateLevelDialogVisible"
      :title="$l('choose_department') || '选择部门机构'"
      :depCode="updateLevelDialogOptions.depCode"
      :orgCode="updateLevelDialogOptions.orgCode"
      @confirm="updateLevel"
    />
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../../edit-form'
import UpdateLevelDialog from '../../update-level-dialog/dialog'
export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
    UpdateLevelDialog,
  },
  mixins: [BaseTable],
  props: {
    orgRow: {type: Object, default: () => null},
  },
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
      parentDep: {},

      updateLevelDialogVisible: false,
      updateLevelDialogOptions: {
        depCode: '',
        orgCode: '',
      },
    }
  },
  mounted() {},
  watch:{
    orgRow(val){
      this.$refs.header.orgChange(val)
    }
  },
  methods: {
    getData(form) {
      this.parentDep = {}
      this.loading = true
      this.$api
        .sysDepartmentListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({type, code = ''}) {
      const types = {
        edit: this.$l('from_label_edit_business') || '编辑业务部门信息',
        add: this.$l('from_label_add_business') || '添加业务部门信息',
        detail: this.$l('from_label_details_business') || '业务部门信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    depRowChange(row) {
      this.parentDep = row
    },
    openUpdateLevelDialog() {
      const parentCode = this.parentDep.depCode
      if (!parentCode) {
        this.$message.warning(
          this.$l('from_label_pe_department') || '请先选择一个部门！'
        )
        return
      }

      this.updateLevelDialogVisible = true
      this.updateLevelDialogOptions = {
        depCode: this.parentDep.depCode,
        orgCode: this.orgRow.orgCode,
      }
    },
    //批量更新层级
    updateLevel(data) {
      if (!data) return

      if (data.isLast === 'Y') {
        this.$message.warning(
          this.$l('tips_noLast') || '不能移动至处于末级的部门！'
        )
        return
      }

      this.$confirm(
        this.$l('tips_move') || '是否要批量移动部门？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .sysDepartmentUpdateLevelApi({
            depCode: this.parentDep.depCode,
            parentCode: data.depCode,
            orgCode: data.orgCode,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_operate_ok') || '操作成功',
              type: 'success',
            })
            this.reload()
          })
      })
    },
  },
}
</script>
